import { Link } from "@tanstack/react-router";
import type { AssetTreeSearch } from "../../lib/assetTreeSearch";
import type { NavigationOrigin } from "../../lib/navigationOrigin";
import { BackCrumb, ContextualBack, useScopeSearch } from "./ContextualBack";

export function AssetDetailBack({
  assetTreeSearch,
  origin,
}: {
  assetTreeSearch?: AssetTreeSearch;
  origin?: NavigationOrigin;
}) {
  return (
    <ContextualBack
      fallback={<BackToAssets assetTreeSearch={assetTreeSearch} />}
      origin={origin}
    />
  );
}

function BackToAssets({
  assetTreeSearch,
}: {
  assetTreeSearch?: AssetTreeSearch;
}) {
  const search = { ...useScopeSearch(), ...assetTreeSearch };

  return (
    <BackCrumb label="Assets" link={<Link search={search} to="/assets" />} />
  );
}
